import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summarizeLinkContent: {
		id: 'ai-proactive-description-completer.summarize-link-content',
		defaultMessage: 'Generate description',
		description: 'Prompt indicating that the AI is summarizing the content of the link',
	},
	closeFooter: {
		id: 'ai-proactive-description-completer.close-footer',
		defaultMessage: 'Close',
		description: 'Message to indicate that the button can initiate an action to close the footer',
	},
});
